import React from 'react'

function Why() {
  return (
    <section className="container-fluid p-3 p-md-5">
        <div className="row">
            <div className="col-md-7">
                <h1 className="fs-1 fw-bold text-white">What , <span className="text-aqua">Why</span> and How </h1>.
                <p className="fs-5 text-white">
                <span className="text-aqua">Rocketshots</span> is your one-stop solution for all your Digital needs We offer a comprehensive suite of digital marketing services designed to meet your business objectives. Our team of experts provide customized solutions that are tailored to your specific needs. We specialize in creating and maintaining digital content, managing social media campaigns, product and brand digital marketing, search engine optimization, and more. We have the experience and expertise to help you get the most out of your digital strategies..  

                </p>
                <p className="fs-5 text-white">
                We at Rocket shots believe in propelling our client product and content to greater success by adding cinematic elements of emotions and fun that connect to a larger audience thereby creating a charismatic impact of the product globally, enabling greater product visibility and higher brand engagement rates.
                </p>
                <p className="fs-5 text-white">
                Leveraging our clients as their Digital content & marketing partners we ride on the latest market and social media trends to ensure high visual-to-purchase conversion rates. 
                </p>
            </div>
            <div className="col-md-5">
                <img src="https://img.freepik.com/premium-photo/silhouette-executive-with-question-mark-sign-blurred-people-background-dark-grey-background_1143998-22292.jpg?ga=GA1.1.1538238808.1729515699&semt=ais_hybrid" alt="" className="w-100" />
            </div>
        </div>
    </section>
  )
}

export default Why